import React, { useState, useEffect } from 'react';
import { useLocation, Link,useParams  } from 'react-router-dom';
import './Articles.css';
import { getItemTitleList, getProjectCategory } from "../../api";
const Articles = () => {
  const [selectedLetter, setSelectedLetter] = useState('A');
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [showAllArticles, setShowAllArticles] = useState(false);
  const location = useLocation();

  const alphabet = ['A', 'B', 'C', 'Ç', 'D', 'E', 'F', 'G', 'Ğ', 'H', 'I', 'İ', 'J', 'K', 'L', 'M', 'N', 'O', 'Ö', 'P', 'R', 'S', 'Ş', 'T', 'U', 'Ü', 'V', 'Y', 'Z'];
  const numbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '(', ')'];

  const letterGroups = {
    'A-E': ['A', 'B', 'C', 'Ç', 'D', 'E'],
    'F-J': ['F', 'G', 'Ğ', 'H', 'I', 'İ', 'J'],
    'K-P': ['K', 'L', 'M', 'N', 'O', 'Ö', 'P'],
    'R-Z': ['R', 'S', 'Ş', 'T', 'U', 'Ü', 'V', 'Y', 'Z'],
    '0-9': numbers
  };

 
  const params = useParams()
	const {catId} = params; 
// console.log('catId ', catId )
  const [data,setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [selectedChar, setSelectedChar] = useState('');

  const getAPI = async()=>{
    const resSlider = await getItemTitleList();
    const resCat = await getProjectCategory();

    // console.log('API Response:', resSlider.data);
    
    if(resSlider.status){
      const items = catId === undefined ? resSlider.data : resSlider.data.filter(x=>x.categoryId === Number(catId));
      
      // API verilerini harflere göre gruplandır
      const groupedData = {};
      alphabet.forEach(letter => {
        const letterItems = items.filter(item => {
          const firstChar = item.title.charAt(0).toUpperCase();
          return firstChar === letter;
        });
        if (letterItems.length > 0) {
          groupedData[letter] = letterItems;
        }
      });

      // Sayıları gruplandır
      numbers.forEach(num => {
        const numItems = items.filter(item => {
          const firstChar = item.title.charAt(0);
          return firstChar === num;
        });
        if (numItems.length > 0) {
          groupedData[num] = numItems;
        }
      });

      setData(groupedData);
      setFilteredData(groupedData);
      setCategoryData(resCat.data);
    }
  }

  useEffect(() => {
    getAPI();
  }, [catId]);

  // URL'den gelen state'i kontrol et
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const group = params.get('group');
    if (group && letterGroups[group]) {
      setSelectedGroup(group);
      setSelectedLetter(letterGroups[group][0]);
      setShowAllArticles(false);
    } else {
      // Eğer herhangi bir group parametresi yoksa, tüm maddeler gösterilecek
      setSelectedGroup(null);
      setSelectedLetter('A');
      setShowAllArticles(true);
    }
  }, [location]);

  const handleLetterClick = (letter) => {
    setSelectedLetter(letter);
    setShowAllArticles(false);
  };

  const handleGroupClick = (group) => {
    setSelectedGroup(group);
    const firstItem = letterGroups[group][0];
    setSelectedLetter(firstItem);
    setShowAllArticles(false);
  };

  // Görünecek harfleri belirle
  const visibleLetters = selectedGroup ? letterGroups[selectedGroup] : alphabet;

  return (
    <div className="articles-container">
      {categoryData.length > 0 && 
        <div className="category-nav">
          <Link 
            className={`category-item ${catId === undefined ? "active" : ""}`} 
            to="/maddeler"
          >
            Tümü
          </Link>
          {categoryData.map((cat, index) => (
            <Link 
              key={index}
              className={`category-item ${Number(catId) === cat.id ? "active" : ""}`} 
              to={`/maddeler/kategori/${cat.id}`}
            >
              {cat.name}
            </Link>
          ))}
        </div>
      }

      <div className="letter-groups mb-3">
        {Object.keys(letterGroups).map((group) => (
          <div
            key={group}
            className={`letter-group ${selectedGroup === group ? 'active' : ''}`}
            onClick={() => handleGroupClick(group)}
          >
            {group}
          </div>
        ))}
      </div>

      <div className="alphabet-nav">
        <span
          className={`letter ${showAllArticles ? 'active' : ''}`}
          onClick={() => setShowAllArticles(true)}
        >
          Tümü
        </span>
        {visibleLetters.map((letter) => (
          <span
            key={letter}
            className={`letter ${selectedLetter === letter && !showAllArticles ? 'active' : ''}`}
            onClick={() => handleLetterClick(letter)}
          >
            {letter}
          </span>
        ))}
      </div>

      <div className="articles-content">
        {showAllArticles ? (
          // Tüm maddeler gösterimi
          <div className="all-articles-section">
            <div className="letter-title">Tüm Maddeler</div>
            <img
              src="/images/cdtst/dekoratif.png"
              alt="Dekoratif çizgi"
              className="decorative-line"
            />
            {alphabet.concat(numbers).map((letter) => 
              data[letter] && data[letter].length > 0 ? (
                <div key={letter} className="letter-group-section">
                  <h3 className="letter-group-title">{letter}</h3>
                  <div className="articles-list">
                    {data[letter].map((article) => (
                      <Link
                        to={`/article/${article.id}`}
                        key={article.id}
                        className="article-link"
                        state={{
                          articleInfo: {
                            id: article.id,
                            title: article.title,
                            englishTitle: article.definition,
                            years: article.years,
                            content: article.content,
                            image: article.primaryImage
                          }
                        }}
                      >
                        <div className="article-card">
                          <h3>{article.title}</h3>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              ) : null
            )}
          </div>
        ) : (
          // Tekil harf gösterimi
          <div className="letter-section">
            <div className="letter-title">{selectedLetter}</div>
            <img
              src="/images/cdtst/dekoratif.png"
              alt="Dekoratif çizgi"
              className="decorative-line"
            />
            <div className="articles-list">
              {data[selectedLetter]?.map((article, index) => (
                <Link
                  to={`/article/${article.id}`}
                  key={article.id}
                  className="article-link"
                  state={{
                    articleInfo: {
                      id: article.id,
                      title: article.title,
                      englishTitle: article.definition,
                      years: article.years,
                      content: article.content,
                      image: article.primaryImage
                    }
                  }}
                >
                  <div className="article-card">
                    <h3>{article.title}</h3>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Articles; 